// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MtGNF","header__content":"Header_header__content__gaido","language":"Header_language__-yMLl"};